import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { MenuItems } from "./common/MenuItems";
import { getUserRoles } from "../../config/user";

const AdminSideBar = ({ collapsed }) => {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);
  const role = getUserRoles(); // 💡 replace this with dynamic user role if needed
  // Filter items based on role
  const filteredMenuItems = MenuItems.filter((item) => {
          // alert(role[0])
    const hasAccess = item.roles?.includes(role[0]);
    if (item.children) {
      item.children = item.children.filter((child) =>
        child.roles?.includes(role[0])
      );
      return item.children.length > 0; // keep parent if it has visible children
    }
    return hasAccess;
  });

  // Determine active parent menu based on path
  useEffect(() => {
    const activeParent = filteredMenuItems.find((item) =>
      item.children?.some((child) => location.pathname === child.path)
    );
    if (activeParent) {
      setOpenMenu(activeParent.name);
    }
  }, [location.pathname]);

  const handleToggleMenu = (name) => {
    setOpenMenu((prev) => (prev === name ? null : name));
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className={`admin-sidebar-inner ${collapsed ? "collapsed" : ""}`}>
      <div className="admin-sidebar-logo text-center py-3">
        <img src="/images/sys-new-logo2.png" alt="Logo" className="img-fluid" />
      </div>

      <div className="admin-sidebar-menu">
        <ul className="nav flex-column">
          {filteredMenuItems.map((item, index) => {
            const isDropdownOpen = openMenu === item.name;

            return (
              <li className="nav-item mb-2" key={index}>
                {item.children ? (
                  <>
                    <button
                      className={`admin-nav-btn w-100 d-flex align-items-center justify-content-between ${
                        isDropdownOpen ? "admin-nav-btn-active" : ""
                      }`}
                      onClick={() => handleToggleMenu(item.name)}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <span className="admin-nav-icon">{item.icon}</span>
                        {!collapsed && item.name}
                      </div>
                      {!collapsed && (
                        <span className="admin-nav-arrow">
                          {isDropdownOpen ? (
                            <FaChevronDown />
                          ) : (
                            <FaChevronRight />
                          )}
                        </span>
                      )}
                    </button>
                    {!collapsed && isDropdownOpen && (
                      <ul className="admin-submenu nav flex-column ms-4 open">
                        {item.children.map((child, idx) => (
                          <li className="nav-item" key={idx}>
                            <Link
                              className={`nav-link d-flex align-items-center gap-2 admin-submenu-link ${
                                isActive(child.path)
                                  ? "admin-nav-btn-active"
                                  : ""
                              }`}
                              to={child.path}
                            >
                              <span className="admin-nav-icon">
                                {child.icon}
                              </span>
                              {child.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                ) : (
                  <Link
                    to={item.path}
                    className={`nav-link d-flex align-items-center gap-2 admin-nav-btn ${
                      isActive(item.path) ? "admin-nav-btn-active" : ""
                    }`}
                  >
                    <span className="admin-nav-icon">{item.icon}</span>
                    {!collapsed && item.name}
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default AdminSideBar;
